export const SetA1: string[] = [
	'content-state',
	'admin-announcement-banner',
	'restrictions',
	'whiteboard-common',
	'content-ownership',
	'experiment-personalized-templates-v2',
	'space-permissions',
	'trial-components',
];
export const SetA2: string[] = [
	'content-state',
	'admin-announcement-banner',
	'restrictions',
	'whiteboard-common',
	'content-ownership',
	'experiment-personalized-templates-v2',
	'space-permissions',
	'trial-components',
	'template-preview',
	'grant-access-dialog',
	'premium-trial',
	'app-navigation',
	'content-renderer',
	'comments-data',
	'create-space',
	'experiment-ai-in-editor-eot',
	'advanced-search',
	'attachments-page',
	'quick-summary',
	'space-directory',
	'content-history-new',
	'nbm-performance-report',
	'live-pages-features',
	'access-requests',
];
export const SetA3: string[] = [
	'action-buttons',
	'reactions',
	'content-state',
	'admin-announcement-banner',
	'restrictions',
	'whiteboard-common',
	'content-ownership',
	'experiment-personalized-templates-v2',
	'space-permissions',
	'trial-components',
	'template-preview',
	'grant-access-dialog',
	'premium-trial',
	'app-navigation',
	'content-renderer',
	'comments-data',
	'create-space',
	'experiment-ai-in-editor-eot',
	'advanced-search',
	'attachments-page',
	'quick-summary',
	'space-directory',
	'content-history-new',
	'nbm-performance-report',
	'live-pages-features',
	'access-requests',
	'activity-filter',
	'ai-comments-summary',
	'auto-provisioning-edition-parity',
	'blank-page-quick-actions',
	'blog-posts-macro',
	'blog-tree',
	'breadcrumbs',
	'bulk-permissions',
	'confluence-databases-extension',
	'confluence-embeds',
	'contact-administrator',
	'content-history',
	'content-renderer-legacy-macros',
	'copy-space-permissions',
	'cross-flow',
	'custom-content',
	'edit-button',
	'editor-conversion',
	'editor-revert-dialog',
	'experiment-confluence-enable-end-user-request',
	'experiment-land-users-in-editor-with-revamped-bpqa',
	'experiment-more-product-users-can-upgrade-pay',
	'fabric-extension-lib',
	'fabric-page-optin-migration',
	'favourite-button',
	'import-from-sources',
	'inspect-permissions',
	'mentions-notifications',
	'move-blog-modal',
	'nav-menus',
	'navigation-search-dialog',
	'notifications',
	'page-rovo-config-common',
	'performance-insights',
	'profile',
	'space-manager',
	'snippets',
	'smart-create',
	'template-editor',
	'template-list',
	'version-history',
	'watermark-admin',
	'fabric-providers',
	'inline-comments',
	'inline-comments-hooks',
	'full-page-editor',
	'native-collab',
	'query-preloaders',
	'query-preloader-tools',
	'graphql',
	'editor-features',
	'content-types-header',
	'comments-pubsub',
	'create-blank-fabric-page',
	'templates-cards',
	'blueprints',
	'change-edition',
	'billing-page',
	'onboarding-helpers',
	'no-permission',
	'share-and-restrict-dialog',
	'flags',
	'create-space-preload',
	'space-roles',
	'recent-spaces',
	'delete-space',
	'popular-labels',
	'admin-center',
	'view-page',
	'view-page-common',
	'content-body',
	'content-container',
	'content-prerequisites',
	'content-renderer',
	'content-appearance',
	'inline-highlights-query',
	'page-cover-picture',
	'content-header',
	'content-topper',
	'restrictions',
	'comment-extension-handlers',
	'comment-simple',
	'comments-hooks',
	'comments-panel-utils',
	'comments-query-param-handlers',
	'comments-pubsub',
	'comments-util',
	'confluence-databases',
	'contextual-create',
	'contributors-macro',
	'copy-content-link',
	'copy-page-tree-dialog',
	'core-invites-provider',
	'create-from-template',
	'current-user',
	'custom-content-view',
	'live-page-route-preloader',
	'load-live-page',
	'load-edit-page',
	'live-pages',
	'external-share',
	'confluence-fabric-editor',
];
export const SetA4: string[] = [
	'action-buttons',
	'reactions',
	'content-state',
	'admin-announcement-banner',
	'restrictions',
	'whiteboard-common',
	'content-ownership',
	'experiment-personalized-templates-v2',
	'space-permissions',
	'trial-components',
	'template-preview',
	'grant-access-dialog',
	'premium-trial',
	'app-navigation',
	'content-renderer',
	'comments-data',
	'create-space',
	'experiment-ai-in-editor-eot',
	'advanced-search',
	'attachments-page',
	'quick-summary',
	'space-directory',
	'content-history-new',
	'nbm-performance-report',
	'live-pages-features',
	'access-requests',
	'activity-filter',
	'ai-comments-summary',
	'auto-provisioning-edition-parity',
	'blank-page-quick-actions',
	'blog-posts-macro',
	'blog-tree',
	'breadcrumbs',
	'bulk-permissions',
	'confluence-databases-extension',
	'confluence-embeds',
	'contact-administrator',
	'content-history',
	'content-renderer-legacy-macros',
	'copy-space-permissions',
	'cross-flow',
	'custom-content',
	'edit-button',
	'editor-conversion',
	'editor-revert-dialog',
	'experiment-confluence-enable-end-user-request',
	'experiment-land-users-in-editor-with-revamped-bpqa',
	'experiment-more-product-users-can-upgrade-pay',
	'fabric-extension-lib',
	'fabric-page-optin-migration',
	'favourite-button',
	'import-from-sources',
	'inspect-permissions',
	'mentions-notifications',
	'move-blog-modal',
	'nav-menus',
	'navigation-search-dialog',
	'notifications',
	'page-rovo-config-common',
	'performance-insights',
	'profile',
	'space-manager',
	'snippets',
	'smart-create',
	'template-editor',
	'template-list',
	'version-history',
	'watermark-admin',
	'fabric-providers',
	'inline-comments',
	'inline-comments-hooks',
	'full-page-editor',
	'native-collab',
	'query-preloaders',
	'query-preloader-tools',
	'graphql',
	'editor-features',
	'content-types-header',
	'comments-pubsub',
	'create-blank-fabric-page',
	'templates-cards',
	'blueprints',
	'change-edition',
	'billing-page',
	'onboarding-helpers',
	'no-permission',
	'share-and-restrict-dialog',
	'flags',
	'create-space-preload',
	'space-roles',
	'recent-spaces',
	'delete-space',
	'popular-labels',
	'admin-center',
	'view-page',
	'view-page-common',
	'content-body',
	'content-container',
	'content-prerequisites',
	'content-renderer',
	'content-appearance',
	'inline-highlights-query',
	'page-cover-picture',
	'content-header',
	'content-topper',
	'restrictions',
	'comment-extension-handlers',
	'comment-simple',
	'comments-hooks',
	'comments-panel-utils',
	'comments-query-param-handlers',
	'comments-pubsub',
	'comments-util',
	'confluence-databases',
	'contextual-create',
	'contributors-macro',
	'copy-content-link',
	'copy-page-tree-dialog',
	'core-invites-provider',
	'create-from-template',
	'current-user',
	'custom-content-view',
	'live-page-route-preloader',
	'load-live-page',
	'load-edit-page',
	'live-pages',
	'custom-content-view',
	'data-lifecycle-management',
	'data-security',
	'delete-pages',
	'delete-space',
	'edit-features',
	'edit-space-logo',
	'edition-awareness',
	'editor-breadcrumbs',
	'editor-context-panel-content-creation-panel',
	'editor-ellipsis-dropdown',
	'editor-flags',
	'editor-help',
	'editor-move-page-button',
	'editor-offline-storage',
	'editor-preview',
	'editor-primary-toolbar-components',
	'editor-schedule-publish',
	'entity-operations',
	'error-types',
	'excerpt-include',
	'experiment-cfind-5139-confluence-aifc-onboarding',
	'experiment-cfind-5291-template-touchpoint',
	'experiment-contextual-collab-onboarding-for-new-end-users',
	'experiment-home-onboarding-takeover-v2',
	'experiment-nth-user-orientation',
	'experiment-reverse-trial-message-suppression',
	'experiment-simplify-nav-new-user',
	'experiment-suggest-whiteboard-based-on-page-title',
	'experiment-tailor-in-product-journey-sub-anchors',
	'experiment-teammate-content-screen-page',
	'export-space',
	'external-collab-ui',
	'external-share-utils',
	'fabric-extension-queries',
	'feature-discovery',
	'folder',
	'folder-conversion',
	'global-feedback-collector',
	'global-operations',
	'graphql-error-processor',
	'highlight-actions',
	'in-product-help',
	'in-trial-feature-gates-banner',
	'inconsistent-license',
	'inline-comments-reattach',
	'inline-highlights-query',
	'integrations-discovery',
	'issue-create-side-panel',
	'keyboard-shortcuts-dialog',
	'labels-footer',
	'live-search',
	'mobile-app-macro-renderer',
	'mobile-web',
	'monitoring',
	'move-pencil-button',
	'network',
	'onboarding-setup-modal-common',
	'onboarding-state-update-tooling',
	'page-catchup',
	'page-cover-picture',
	'page-footer-comments',
	'page-header-loom-button',
	'page-info',
	'page-layout',
	'page-selection-table',
	'page-selector',
	'page-utils',
	'pagetree-macro',
	'permissions-principals',
	'persistent-invite-button',
	'persistent-upgrade',
	'powered-by-templates',
	'premium-onboarding',
	'presentation-mode',
	'profile-macros',
	'prompt-competitor-link',
	'publish-page-as-blog',
	'quick-reload',
	'recently-updated-macro',
	'redactions',
	'redirect-legacy-view-page',
	'render-for-feature-flag',
	'roles-hub',
	'screen',
	'search-breadcrumbs',
	'smart-create-page-editor',
	'smart-link-droppable',
	'spa-view-context',
	'space-access-details',
	'space-base',
	'space-curation',
	'space-pages',
	'space-selector',
	'storage-enforcement',
	'super-admin',
	'team-admin-controls',
	'template-card',
	'template-migration-preview',
	'template-suggestions',
	'template-utils',
	'theming',
	'title-area-content-components',
	'topics',
	'unified-analytics',
	'update-content-property-utils',
	'user-and-group-search',
	'whiteboard',
	'whiteboard-extension',
	'add-personal-space-dialog',
	'adf-renderer',
	'analytics',
	'anonymous-access',
	'archive-space',
	'archived-pages-list',
	'audit-log',
	'automation',
	'automation-menu',
	'automated-meeting-notes',
	'beta-features',
	'comment-button',
	'conditional-publish-dialog',
	'content-by-label-macro',
	'content-metadata',
	'content-title',
	'content-tools',
	'content-tree-actions',
	'content-tree-search',
];
export const ALL: string[] = [
	'access-links',
	'access-requests',
	'action-buttons',
	'activity-filter',
	'add-personal-space-dialog',
	'adf-renderer',
	'admin-announcement-banner',
	'admin-center',
	'advanced-search',
	'agent-mention',
	'ai-comments-summary',
	'ai-floating-context-menu',
	'ai-planner-confluence-bridge-route',
	'ai-rovo-button',
	'analytics',
	'annotation-provider-inline-comments',
	'anonymous-access',
	'app-navigation',
	'approvals',
	'archive-pages',
	'archive-space',
	'archived-pages-list',
	'attachments-macro',
	'attachments-page',
	'audio',
	'audit-log',
	'auto-provisioning-edition-parity',
	'automated-meeting-notes',
	'automation',
	'automation-discovery',
	'automation-extensions',
	'automation-menu',
	'beta-features',
	'billing-page',
	'blank-page-quick-actions',
	'blog-posts-macro',
	'blog-tree',
	'blueprints',
	'breadcrumbs',
	'bulk-page-actions',
	'bulk-permissions',
	'byline-connections',
	'change-edition',
	'change-history-macro',
	'comment',
	'comment-button',
	'comment-extension-handlers',
	'comment-simple',
	'comments-data',
	'comments-data-manager',
	'comments-hooks',
	'comments-panel',
	'comments-panel-queries',
	'comments-panel-utils',
	'comments-pubsub',
	'comments-query-param-handlers',
	'comments-util',
	'company-hub',
	'company-hub-utils',
	'conditional-publish-dialog',
	'confluence-analytics',
	'confluence-databases',
	'confluence-databases-extension',
	'confluence-embeds',
	'confluence-fabric-editor',
	'confluence-frontend-server',
	'confluence-post-office-provider',
	'contact-administrator',
	'content-appearance',
	'content-body',
	'content-by-label-macro',
	'content-container',
	'content-header',
	'content-history',
	'content-history-new',
	'content-markdown-mode',
	'content-metadata',
	'content-ownership',
	'content-prerequisites',
	'content-quick-actions',
	'content-renderer',
	'content-renderer-legacy-macros',
	'content-report-table-macro',
	'content-smartlinks',
	'content-state',
	'content-title',
	'content-tools',
	'content-topper',
	'content-tree-actions',
	'content-tree-search',
	'content-types-header',
	'content-types-utils',
	'contextual-create',
	'contextual-reading-aids',
	'contributors-macro',
	'copy-content-link',
	'copy-page-tree-dialog',
	'copy-space-permissions',
	'core-invites-provider',
	'create-blank-fabric-page',
	'create-content-from-template',
	'create-from-template',
	'create-space',
	'create-space-preload',
	'cross-flow',
	'current-user',
	'custom-content',
	'custom-content-view',
	'custom-header-footer',
	'custom-sites-extensions',
	'customize-navigation',
	'data-classification',
	'data-lifecycle-management',
	'data-security',
	'default-space-permissions',
	'delete-pages',
	'delete-space',
	'details-panel',
	'dev-docs',
	'edit-button',
	'edit-features',
	'edit-space-logo',
	'edition-awareness',
	'editor-action-bar',
	'editor-breadcrumbs',
	'editor-content-mode-button',
	'editor-context-panel-content-creation-panel',
	'editor-conversion',
	'editor-ellipsis-dropdown',
	'editor-features',
	'editor-flags',
	'editor-help',
	'editor-move-page-button',
	'editor-offline-storage',
	'editor-preloader',
	'editor-presets',
	'editor-preview',
	'editor-primary-toolbar-components',
	'editor-revert-dialog',
	'editor-schedule-publish',
	'emoji-title',
	'entity-operations',
	'error-types',
	'excerpt-include',
	'experiment-ai-collaboration-brief',
	'experiment-ai-in-editor-eot',
	'experiment-cfind-5139-confluence-aifc-onboarding',
	'experiment-cfind-5291-template-touchpoint',
	'experiment-twcg-2304-import-in-onboarding',
	'experiment-confluence-enable-end-user-request',
	'experiment-contextual-collab-onboarding-for-new-end-users',
	'experiment-editor-title-area-banner',
	'experiment-home-onboarding-takeover-v2',
	'experiment-inline-reactions',
	'experiment-land-users-in-editor-with-revamped-bpqa',
	'experiment-more-product-users-can-upgrade-pay',
	'experiment-nth-user-orientation',
	'experiment-omnibar',
	'experiment-personalized-templates-v2',
	'experiment-reverse-trial-message-suppression',
	'experiment-rovo-onboarding-twcg-1387',
	'experiment-simplify-nav-new-user',
	'experiment-suggest-whiteboard-based-on-page-title',
	'experiment-tailor-in-product-journey-sub-anchors',
	'experiment-teammate-content-screen-page',
	'experiment-twcg-1489-cc-3p-connector-onboarding',
	'experiment-twc-aifc-onboarding',
	'export-space',
	'external-collab-ui',
	'external-share',
	'external-share-utils',
	'fabric-extension-handlers',
	'fabric-extension-legacy-macro-renderer',
	'fabric-extension-lib',
	'fabric-extension-queries',
	'fabric-media-support',
	'fabric-page-optin-migration',
	'fabric-providers',
	'favourite-button',
	'feature-discovery',
	'feed',
	'flags',
	'folder',
	'folder-conversion',
	'forge-ui',
	'full-page-editor',
	'global-feedback-collector',
	'global-operations',
	'grant-access-dialog',
	'graphql',
	'graphql-error-processor',
	'highlight-actions',
	'home',
	'import-content',
	'import-from-sources',
	'importer-dashboard',
	'in-product-help',
	'in-trial-feature-gates-banner',
	'inconsistent-license',
	'inline-comments',
	'inline-comments-common',
	'inline-comments-hooks',
	'inline-comments-reattach',
	'inline-highlights-query',
	'inspect-permissions',
	'integrations-discovery',
	'issue-create-side-panel',
	'keyboard-shortcuts-dialog',
	'labels',
	'labels-footer',
	'legacy-schema-bridge',
	'link-to-this-page-dialog',
	'live-page-route-preloader',
	'live-pages',
	'live-pages-features',
	'live-pages-utils',
	'live-search',
	'load-edit-page',
	'load-live-page',
	'local-activity',
	'loom-utils',
	'main-layout',
	'manage-pages',
	'manage-watcher-dialog',
	'media-client',
	'mentions-notifications',
	'mobile-app-macro-renderer',
	'mobile-web',
	'monitoring',
	'move-blog-modal',
	'move-pencil-button',
	'native-collab',
	'nav-menus',
	'navigation-search-dialog',
	'nbm-migration',
	'nbm-performance-report',
	'network',
	'no-permission',
	'not-found',
	'notifications',
	'object-comments',
	'onboarding',
	'onboarding-account-setup-modal',
	'onboarding-helpers',
	'onboarding-nth-user-setup-modal',
	'onboarding-setup-modal-common',
	'onboarding-state-update-tooling',
	'page-card',
	'page-catchup',
	'page-comments-queries',
	'page-cover-picture',
	'page-footer-comments',
	'page-header-loom-button',
	'page-include-macro',
	'page-info',
	'page-layout',
	'page-pdf-export',
	'page-properties-report-renderer',
	'page-recommendations',
	'page-restrictions-context',
	'page-rovo-config-common',
	'page-selection-table',
	'page-selector',
	'page-splitter',
	'page-tree',
	'page-utils',
	'pagetree-macro',
	'pagetree-search-macro',
	'performance-insights',
	'permissions-principals',
	'persistent-invite-button',
	'persistent-upgrade',
	'popular-labels',
	'popular-labels-macro',
	'powered-by-templates',
	'preload-macros',
	'preload-storage-queries',
	'premium-onboarding',
	'premium-trial',
	'presentation-mode',
	'profile',
	'profile-macros',
	'prompt-competitor-link',
	'public-links',
	'publish-modal',
	'publish-page-as-blog',
	'query-group',
	'query-preloader-tools',
	'query-preloaders',
	'query-preloaders-common',
	'quick-reload',
	'quick-summary',
	'reactions',
	'read-time',
	'recent-spaces',
	'recently-updated-macro',
	'redactions',
	'redirect-legacy-view-page',
	'render-for-feature-flag',
	'resolved-inline-comments-dialog',
	'restrictions',
	'roles-hub',
	'screen',
	'search-breadcrumbs',
	'session-data',
	'share-and-restrict-dialog',
	'side-navigation',
	'site-operations',
	'site-permissions',
	'site-settings',
	'smart-card-provider',
	'smart-create',
	'smart-create-page-editor',
	'smart-folder',
	'smart-link-droppable',
	'snippets',
	'spa-view-context',
	'space-access-details',
	'space-base',
	'space-contributors',
	'space-curation',
	'space-directory',
	'space-guest-list',
	'space-manager',
	'space-overview',
	'space-pages',
	'space-permissions',
	'space-roles',
	'space-selector',
	'space-settings',
	'space-shortcuts',
	'space-suggestions',
	'space-utils',
	'space-views',
	'storage-enforcement',
	'super-admin',
	'targeting',
	'tasks-report-macro',
	'team-admin-controls',
	'team-calendar',
	'team-presence',
	'template-card',
	'template-editor',
	'template-gallery',
	'template-list',
	'template-migration-preview',
	'template-preview',
	'template-suggestions',
	'template-utils',
	'templates-cards',
	'theming',
	'title-area-content-components',
	'topics',
	'trial-components',
	'unified-analytics',
	'unread-comments',
	'update-content-property-utils',
	'user-and-group-search',
	'version-history',
	'view-page',
	'view-page-common',
	'view-page-gateway',
	'viewpdf-macro',
	'viewxls-macro',
	'watch-dialog',
	'watermark-admin',
	'web-item-location',
	'web-panel-location',
	'whiteboard',
	'whiteboard-common',
	'whiteboard-extension',
	'wrm',
];

/**
 * Sentinel entry that enables Relay for *every* package, including packages that appear in no set at
 * all — {@link ALL} is a hardcoded list and therefore always lags behind the packages that actually
 * exist. It is deliberately not a real package name, so a consumer that only reads the expanded list
 * (and does not honour {@link ResolvedRelayEnabledPackages.enablesEveryPackage}) matches nothing
 * rather than silently enabling everything while ignoring exclusions.
 */
export const EVERY_PACKAGE_WILDCARD = '*';

/**
 * `set:EVERYTHING` — an unbounded allowlist, as opposed to {@link ALL}, which is bounded by whatever
 * was enumerated above. Modelled as a set so it composes with the rest of the configuration syntax:
 * `["set:EVERYTHING", "-favourite-button"]` puts every package on Relay *except* `favourite-button`,
 * because `-` exclusions are applied after the wildcard and always win.
 */
export const EVERYTHING: string[] = [EVERY_PACKAGE_WILDCARD];

/**
 * Every key MUST match {@link packageSetPattern}, otherwise the key is unreachable: a configured
 * value that does not match the pattern is treated as a literal package name rather than a set
 * reference, matches no real package, and silently contributes nothing. The
 * `every defined set expands` test in `__tests__/relayEnabledPackageSets-test.ts` enforces this.
 */
export const relayEnabledPackageSets: Readonly<Record<string, ReadonlyArray<string>>> = {
	'set:A1': SetA1,
	'set:A2': SetA2,
	'set:A3': SetA3,
	'set:A4': SetA4,
	'set:ALL': ALL,
	'set:EVERYTHING': EVERYTHING,
};

/**
 * Matches any `set:<name>` reference, where `<name>` is alphanumeric — both the numbered sets
 * (`set:A1`) and named ones (`set:ALL`).
 *
 * Historically this was `/^set:[A-Z]\d+$/`, which required a digit suffix and therefore did NOT
 * match `set:ALL`. That made `'set:ALL'` fall through to the literal-package-name branch below, so
 * configuring it enabled Relay for *zero* packages instead of all of them — indistinguishable from
 * `?disableRelay=1`, and silent.
 */
const packageSetPattern = /^set:[A-Za-z0-9]+$/;

export type ResolvedRelayEnabledPackages = {
	/**
	 * Whether the configuration enables Relay for every package — i.e. {@link EVERY_PACKAGE_WILDCARD}
	 * survived expansion, which `set:EVERYTHING` produces. When true, `enabledPackages` is *not* the
	 * full answer: a caller absent from it is still enabled, unless it is excluded.
	 */
	enablesEveryPackage: boolean;
	/** Packages enabled by an expanded set or configured verbatim, with exclusions already removed. */
	enabledPackages: string[];
	/**
	 * Packages configured with a `-` prefix, unprefixed. These must be checked *before*
	 * {@link ResolvedRelayEnabledPackages.enablesEveryPackage} — an exclusion beats the wildcard.
	 */
	excludedPackages: string[];
};

/**
 * Resolves the Relay rollout configuration into the three things a routing decision needs: whether
 * the wildcard is in play, the finite allowlist, and the exclusions.
 *
 * Set references (`set:A1`, `set:ALL`, `set:EVERYTHING`) expand to their hardcoded lists; explicitly
 * configured packages are preserved verbatim; undefined set references contribute nothing.
 *
 * Packages prefixed with `-` (e.g. `-access-links`) are exclusions and take precedence over
 * everything else regardless of ordering — including over `set:EVERYTHING`, which is why they are
 * returned separately instead of only being filtered out of `enabledPackages`.
 */
export function resolveRelayEnabledPackages(
	configuredPackages: ReadonlyArray<string>,
	packageSets: Readonly<Record<string, ReadonlyArray<string>>> = relayEnabledPackageSets,
): ResolvedRelayEnabledPackages {
	const excludedPackages = configuredPackages.flatMap((configuredPackage) =>
		configuredPackage.startsWith('-') ? [configuredPackage.slice(1)] : [],
	);
	const excludedPackageSet = new Set(excludedPackages);

	const expandedPackages = configuredPackages.flatMap((configuredPackage) => {
		if (configuredPackage.startsWith('-')) {
			return [];
		}

		if (!packageSetPattern.test(configuredPackage)) {
			return [configuredPackage];
		}

		return packageSets[configuredPackage] ?? [];
	});

	const enabledPackages = expandedPackages.filter(
		(expandedPackage) => !excludedPackageSet.has(expandedPackage),
	);

	return {
		// Derived from the filtered list so that `-*` turns the wildcard back off, consistent with
		// exclusions winning everywhere else.
		enablesEveryPackage: enabledPackages.includes(EVERY_PACKAGE_WILDCARD),
		enabledPackages,
		excludedPackages,
	};
}

/**
 * Expands package-set references from the Relay rollout configuration into their hardcoded package
 * lists, while preserving explicitly configured packages and ignoring undefined set references.
 *
 * Packages prefixed with `-` (e.g. `-access-links`) are treated as exclusions: the referenced
 * package is omitted from the final list even if it was included by an expanded set or configured
 * explicitly, regardless of ordering.
 *
 * Note that `set:EVERYTHING` cannot be represented as a finite list — it expands to
 * {@link EVERY_PACKAGE_WILDCARD}, which matches no package name. Anything making an enablement
 * decision must use {@link resolveRelayEnabledPackages} instead, so the wildcard is honoured.
 */
export function expandRelayEnabledPackageSets(
	configuredPackages: ReadonlyArray<string>,
	packageSets: Readonly<Record<string, ReadonlyArray<string>>> = relayEnabledPackageSets,
): string[] {
	return resolveRelayEnabledPackages(configuredPackages, packageSets).enabledPackages;
}
